var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-page login-1" }, [
    _c("div", { staticClass: "login-wrapper" }, [
      _c(
        "div",
        { staticClass: "login-box" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _c("div", { staticClass: "page-copyright" }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo-main" }, [
      _c("a", { attrs: { href: "/admin" } }, [
        _c("h2", { staticStyle: { color: "white" } }, [
          _vm._v("Authorization"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }